import { Button } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useMemo } from "react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useCreateMyDocument } from "../../api/queries";
import {
  buildDocumentCreateStockPrefill,
  parseQiCreatePrefillSearch,
} from "../../lib/qi-create-prefill";
import { DocumentCreateForm } from "../../ui/DocumentCreateForm";

export function MyDocumentCreatePage() {
  const nav = useNavigate({ from: "/app/my-documents/new" });
  const search = useSearch({ from: "/app/my-documents/new" });
  const stockPrefill = useMemo(
    () => buildDocumentCreateStockPrefill(parseQiCreatePrefillSearch(search)),
    [search],
  );
  const createMutation = useCreateMyDocument();

  const handleSubmit = (payload: {
    documentType: string;
    status: "draft" | "issued";
    documentNumber: string;
    customerId: string | null;
    customerName: string;
    customerAddress: string | null;
    customerContact: string | null;
    issueDate: string | null;
    dueDate: string | null;
    referencePo: string | null;
    paymentTerms: string | null;
    notes: string | null;
    templateId: string | null;
    items: Array<{
      description: string;
      quantity: number;
      unit: string | null;
      unitPrice: number;
      discountAmount?: number;
      taxRate?: number;
      productId?: string | null;
      rawMaterialId?: string | null;
    }>;
    discountAmount: number;
    taxRate: number;
    depositPercent: number;
    currency: string;
    showSignature: boolean;
    stockBranchId?: string | null;
  }) => {
    createMutation.mutate(
      {
        documentType: payload.documentType,
        status: payload.status,
        documentNumber: payload.documentNumber || null,
        customerId: payload.customerId ?? null,
        customerName: payload.customerName,
        customerAddress: payload.customerAddress ?? null,
        customerContact: payload.customerContact ?? null,
        issueDate: payload.issueDate ?? null,
        dueDate: payload.dueDate ?? null,
        currency: payload.currency,
        paymentTerms: payload.paymentTerms ?? null,
        notes: payload.notes ?? null,
        templateId: payload.templateId ?? null,
        stockBranchId: payload.stockBranchId ?? null,
        items: payload.items,
        discountAmount: payload.discountAmount,
        taxRate: payload.taxRate,
        depositPercent: payload.depositPercent,
        showSignature: payload.showSignature,
      },
      {
        onSuccess: (data) => {
          nav({
            to: "/app/my-documents/$id",
            params: { id: data.id },
          });
        },
      },
    );
  };

  return (
    <>
      <Header />
      <Main>
        <div className="space-y-2">
          <div className="mb-4 flex items-center justify-between space-x-2">
            <h1 className="font-bold text-2xl tracking-tight">
              ສ້າງເອກະສານໃໝ່
            </h1>
            <Button
              variant="default"
              size="sm"
              onClick={() =>
                nav({
                  to: "/app/my-documents",
                  search: {
                    offset: 0,
                    limit: 20,
                    sort: undefined,
                    filters: undefined,
                  },
                })
              }
              className="gap-2"
            >
              <ArrowLeftIcon className="h-4 w-4" />
              ກັບໄປລາຍການເອກະສານ
            </Button>
          </div>
        </div>

        <DocumentCreateForm
          onSubmit={handleSubmit}
          submitting={createMutation.isPending}
          stockPrefill={stockPrefill}
        />
      </Main>
    </>
  );
}
